module.exports = "<button></button>";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/shared/reembolso/solicitar/template.html
// module id = 3380
// module chunks = 0